import React, { useState } from "react";
import { connect } from "react-redux";
import ConfirmationApproveModel from './ConfirmationApproveModel';
import ConfirmationRejectModel from './ConfirmationRejectModel';
import { FaCheck, FaTimes } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap CSS is included
import "./payout.css";

const PayoutList = () => {
  const [userData, setUserData] = useState([
    { id: 1, name: 'Rohit Sharma', amount: 'Rs.100', status: 'Pending', requestTime: '2024-08-20 10:00 AM' },
    { id: 2, name: 'Krishna Sharma', amount: 'Rs.150', status: 'Pending', requestTime: '2024-08-21 11:00 AM' },
    // Add more static data here as needed
  ]);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [actionType, setActionType] = useState(null); // 'approve' or 'reject'

  const handleAction = (userId, action) => {
    setSelectedUserId(userId);
    setActionType(action);
    if (action === 'approve') {
      setShowApproveModal(true);
    } else {
      setShowRejectModal(true);
    }
  };

  const handleConfirmApprove = () => {
    setUserData(prevData =>
      prevData.map(user =>
        user.id === selectedUserId
          ? { ...user, status: 'Approved' }
          : user
      )
    );
    setShowApproveModal(false);
  };

  const handleConfirmReject = () => {
    setUserData(prevData =>
      prevData.map(user =>
        user.id === selectedUserId
          ? { ...user, status: 'Rejected' }
          : user
      )
    );
    setShowRejectModal(false);
  };

  const handleCloseApprove = () => {
    setShowApproveModal(false);
  };

  const handleCloseReject = () => {
    setShowRejectModal(false);
  };

  return (
    <div className="col-lg-12">
      <div className="card">
        <div className="header">
          <h2>Wholesaler Payout List</h2>
        </div>
        <div className="body table-responsive">
          <table className="table table-hover">
            <thead style={{ textAlign: "center", whiteSpace: "nowrap" }}>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Request Time</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody style={{ textAlign: "center" }}>
              {userData.map((user, index) => (
                <tr key={user.id}>
                  <td>{index + 1}</td>
                  <td>{user.name}</td>
                  <td>{user.amount}</td>
                  <td className={`status-${user.status.toLowerCase()}`}>
                    {user.status}
                  </td>
                  <td>{user.requestTime}</td>
                  <td>
                    {user.status === 'Pending' && (
                      <>
                        <button
                          onClick={() => handleAction(user.id, 'approve')}
                          disabled={user.status !== 'Pending'}
                          title="Approve"
                          className="button-approve"
                        >
                          <FaCheck />
                        </button>
                        <button
                          onClick={() => handleAction(user.id, 'reject')}
                          disabled={user.status !== 'Pending'}
                          title="Reject"
                          className="button-reject"
                        >
                          <FaTimes />
                        </button>
                      </>
                    )}
                    {user.status !== 'Pending' && <span className="status-disabled">Disabled</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Confirmation Modals */}
      <ConfirmationApproveModel
        show={showApproveModal}
        handleClose={handleCloseApprove}
        handleConfirm={handleConfirmApprove}
      />
      <ConfirmationRejectModel
        show={showRejectModal}
        handleClose={handleCloseReject}
        handleConfirm={handleConfirmReject}
      />
    </div>
  );
};

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, {})(PayoutList);
